export default __webpack_public_path__ + "static/media/2033.47cc1508.png";